import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import {getFCLMLink, convertSecondsToTimeFormat, getTimeInSecond} from "../util/Util";
import {getStationCode} from "../network/NetworkUtil";
import {PickContext} from "../pickStatus/context/PickContext";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Tag from "@amzn/meridian/tag";
import Link from "@amzn/meridian/link";
import {CapabilityContext} from "../global/context/CapabilityContext";

const AssociateDetail = (props) => {

    const {viewModel} = useContext(PickContext)
    const {configViewModel} = useContext(CapabilityContext)

    const stationCode = getStationCode();

    const getRouteStatus = (routeStatus) => {
        switch (routeStatus) {
            case "Sidelined":
                return "error";
            case "Picked":
                return "success";
            case "In Progress":
                return "warning";
            default:
                return "neutral";
        }
    }

    const getAssociateRoute = () => {
        const associateRoutes = [];
        viewModel.routeList.forEach(route => {
            if (route.picker === props.associate) {
                associateRoutes.push({
                    routeCode: route.routeCode,
                    status: route.status,
                    progress: route.pickProgress,
                    duration: route.pickDuration,
                    statusTag: getRouteStatus(route.status),
                    startTime: route.startTime,
                    endTime: route.endTime
                })
            }
        });
        return associateRoutes;
    }

    const getAssociatePicklists = () => {
        const associatePicklists = [];
        viewModel.routeList.forEach(route => {
            route.picklists.forEach(picklist => {
                if (picklist.picker === props.associate) {
                    associatePicklists.push({
                        routeCode: route.routeCode,
                        picklistCode: picklist.picklistCode,
                        status: picklist.status,
                        progress: picklist.pickProgress,
                        duration: picklist.pickDuration,
                        statusTag: getRouteStatus(picklist.status),
                        startTime: picklist.startTime,
                        endTime: picklist.endTime
                    })
                }
            })
        });
        return associatePicklists;
    }

    const rowsData = configViewModel.stationConfig.parallelPickEnabled ? getAssociatePicklists() : getAssociateRoute();

    const getAveragePickTime = () => {
        let totalRoutePickTime = 0;
        rowsData.forEach(row => {
            totalRoutePickTime = totalRoutePickTime + getTimeInSecond(row.duration);
        })
        if (rowsData.length > 0) {
            const averagePickTimeInSecond = totalRoutePickTime / rowsData.length
            return convertSecondsToTimeFormat(averagePickTimeInSecond)
        }
        return 0;
    }

    const renderAssociateMetadata = () => {
        return <Row backgroundColor={"secondary"} spacingInset="medium" spacing={"xlarge"}>
            <Row>
                <Text type="h100">
                    <FormattedMessage id="associate.averagePickTime" defaultMessage="Average Pick Duration"/>
                </Text>
                <Text type="b200">{getAveragePickTime()} mins</Text>
            </Row>
            <Row>
                <Text type="h100">
                    <FormattedMessage id="routeInfo.associate" defaultMessage="Associate"/>
                </Text>
                <Link href={getFCLMLink(props.associate, configViewModel.stationConfig.phoneToolLinkChangedToFCLM, stationCode)} type="secondary" target="_blank" rel="noreferrer noopener">
                    {props.associate}
                </Link>
            </Row>
        </Row>
    }

    const renderAssociateTable = () => {
        return <Table headerRows={1} showDividers={true} showStripes={true} spacing="medium">
            {renderAssociateTableHeader()}
            {renderAssociateRows()}
        </Table>
    }

    const renderAssociateTableHeader = () => {
        return <TableRow>
            <TableCell>
                {configViewModel.stationConfig.parallelPickEnabled ?
                    <FormattedMessage id="associate.picklist" defaultMessage="Picklist"/>
                    : <FormattedMessage id="associate.route" defaultMessage="Route"/>
                }
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.status" defaultMessage="Status"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.progress" defaultMessage="Progress"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.duration" defaultMessage="Duration"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.start_time" defaultMessage="Start Time"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.end_time" defaultMessage="End Time"/>
            </TableCell>
        </TableRow>
    }

    const renderAssociateRows = () => {
        return rowsData.map(row => {
            const primaryKey = configViewModel.stationConfig.parallelPickEnabled ? row.picklistCode : row.routeCode;
            return <TableRow key={primaryKey}>
                <TableCell>{primaryKey}</TableCell>
                <TableCell>
                    <Tag type={row.statusTag}>{row.status}</Tag>
                </TableCell>
                <TableCell>{row.progress}</TableCell>
                <TableCell>{row.duration}</TableCell>
                <TableCell>{row.startTime}</TableCell>
                <TableCell>{row.endTime}</TableCell>
            </TableRow>
        })
    }

    return (
        <div>
            <Row widths="100%" spacingInset="small large small">
                <Heading level={3} type="h600" alignment="left">{props.associate}</Heading>
            </Row>
            <Row widths="100%" spacingInset="small large small">
                {renderAssociateMetadata()}
            </Row>
            <Row widths="100%" spacingInset="small large small">
                {renderAssociateTable()}
            </Row>
        </div>
    );
}

export default AssociateDetail


// WEBPACK FOOTER //
// ./src/components/associate/AssociateDetail.js